import React from "react";
import "./Exp.css";

export default function Exp() {
  return (
    <div className="Exp">
      <h1>Experiance</h1>
      <div className="roles">
        <div className="IEEE-WF">
          <h3>Position:</h3> IEEE-VIT | TECH-WEB TEAM ||AUG 2022 - present
          <h3>Responsibilities:</h3>
          <ul>
            <li>
              <p>Managing IEEE-VIT's Official website Creating Websites for</p>{" "}
            </li>
            <li>
              <p>
                Tech-Festivals Created a Discord server for IEEE-VIT Managing
              </p>
            </li>
            <li>
              <p>Technical aspects During Tech Festivals</p>
            </li>
          </ul>
        </div>
        <div className="Unspot-core">
          <h3>Position:</h3> UNSTOP-VIT | SPONSERSHIP CORE ||MAR 2022 - Dec 2022
          <h3>Responsibilities:</h3>
          <ul>
            <li>
              <p>Bring Sponsor for College events</p>
            </li>
            <li>
              <p>Maintaining Relation With clients</p>
            </li>
            <li>
              <p>
                Coordinating with other cores To get details of all the
                resources required
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
